module.exports = __webpack_public_path__ + "img/红兔.293f2987.jpg";